<div class="modal">
    <div>
        <h4 class="titleModal">{{message}}</h4>
    </div>
    <div class="btnModal">
        <button class="mini-button annulla" (click)="close()">NO</button>
        <button class="mini-button conferma" (click)="save()">SI</button>
    </div>
</div>